import React, { Fragment, useEffect, useState, useContext } from "react";
import Input from "../../../common/Input";
import TextArea from "../../../common/TextArea";
import notaContext from "../../../../context/notas_nutriologia/notaContext";
import { MultiSelect } from "react-multi-select-component";


const DietaHabitual = ({features_options}) => {
  
  const notaState = useContext(notaContext);

  const {
    setNotaNutricionalError,
    nota_nutricional_error,
    nota_detalle,
    nota_dieta_habitual,
    setNotaDietaHabitual,
  } = notaState;



  const handleChange = (e) => {
    setNotaDietaHabitual({
      ...nota_dieta_habitual,
      [e.target.name]: e.target.value,
      diet_type: 1,
    });
  };

  const handleChangeSelect = (value) => {
    /* A function that is called when the user selects a feature. It sets the features to the value
    selected by the user. If the user selects no features, it sets the error to true. If the user
    selects a feature, it sets the error to false. */
    setNotaDietaHabitual({
      ...nota_dieta_habitual,
      features: value,
    });
    if (value.length == 0)
    {
      setNotaNutricionalError({
        nota_nutricional_error:true,
      });
    }
    else{
      setNotaNutricionalError({
        nota_nutricional_error:false,
      });
    }
  };


   
  if (!features_options || features_options.length === 0) return null;

  let {
    time_breakfast,
    time_morning_snack,
    time_food,
    time_evening,
    time_dinner,
    time_night_collation,
    breakfast,
    morning_snack,
    food,
    evening_snack,
    dinner,
    night_collation,
    features,
    features_data,
    observations,
  } = nota_dieta_habitual;

  features = features || [];


  return (
    <div className="dieta-habitual">
      <h1>Dieta Habitual</h1>
      <div>
        <div>
          <Input
            type="time"
            name="time_breakfast"
            onChange={handleChange}
            value={time_breakfast}
            label="Hora "
            disabled={nota_detalle ? true : false}
          />

          <TextArea
            type="text"
            name="breakfast"
            onChange={handleChange}
            value={breakfast}
            label="Desayuno "
            disabled={nota_detalle ? true : false}
          />

          <div>
            <label><b>Caracteristicas</b></label>
            {!nota_detalle && features_options && features_options.length > 0?
            
              <MultiSelect
                options={features_options}
                value={features}
                onChange={handleChangeSelect}
                labelledBy="Select"
                name="features"
              />:
              <ul>
              {features_data && features_data.map(item => {
                return <li>{item.label}</li>
              })}
              </ul>
            }
          </div>
        </div>
        <div>
          <Input
            type="time"
            name="time_morning_snack"
            onChange={handleChange}
            value={time_morning_snack}
            label="Hora "
            disabled={nota_detalle ? true : false}
          />

          <TextArea
            type="text"
            name="morning_snack"
            onChange={handleChange}
            value={morning_snack}
            label="Colación "
            disabled={nota_detalle ? true : false}
          />
        </div>
        <div>
          <Input
            type="time"
            name="time_food"
            onChange={handleChange}
            value={time_food}
            label="Hora "
            disabled={nota_detalle ? true : false}
          />

          <TextArea
            type="text"
            name="food"
            onChange={handleChange}
            value={food}
            label="Comida "
            disabled={nota_detalle ? true : false}
          />
        </div>
        <div>
          <Input
            type="time"
            name="time_evening"
            onChange={handleChange}
            value={time_evening}
            label="Hora "
            disabled={nota_detalle ? true : false}
          />

          <TextArea
            type="text"
            name="evening_snack"
            onChange={handleChange}
            value={evening_snack}
            label="Colación "
            disabled={nota_detalle ? true : false}
          />
        </div>

        <div>
          <Input
            type="time"
            name="time_dinner"
            onChange={handleChange}
            value={time_dinner}
            label="Hora "
            disabled={nota_detalle ? true : false}
          />

          <TextArea
            type="text"
            name="dinner"
            onChange={handleChange}
            value={dinner}
            label="Cena "
            disabled={nota_detalle ? true : false}
          />
        </div>
        <div>
          <Input
            type="time"
            name="time_night_collation"
            onChange={handleChange}
            value={time_night_collation}
            label="Hora "
            disabled={nota_detalle ? true : false}
          />

          <TextArea
            type="text"
            name="night_collation"
            onChange={handleChange}
            value={night_collation}
            label="Colación "
            disabled={nota_detalle ? true : false}
          />
        </div>

        <div>
          <TextArea
            name="observations"
            onChange={handleChange}
            value={observations}
            cols="50"
            rows="10"
            label="Observaciones "
            disabled={nota_detalle ? true : false}
          />
        </div>
      </div>
    </div>
  );
};

export default DietaHabitual;
